import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import start from './state';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: start,
  actions,
  getters,
  mutations,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js